<template>
<div class="store_button">
  <button :class="{'head' : isHeading}" class="store_button_style" @click="handleSquareBtnClick">
    {{ text }}
    <div v-if="subText" class="shipped-button" :class="{'button' : url}" @click="goWindow()"> {{ subText }} </div>
    <img v-if="isArrow" class="arrow" src="/img/menu_right.png"/>
  </button>
</div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: 'SKIP',
    },
    subText: {
      type: String,
      default: '',
    },
    isArrow: {
      type: Boolean,
      default: false,
    },
    isHeading: {
      type: Boolean,
      default: false,
    },
    url: {
      type: String,
      default: '',
    },
  },

  methods: {
    handleSquareBtnClick() {
      this.$emit('handleSquareBtnClick');
    },
    goWindow() {
      if (this.url) {
        window.open(this.url, '_blank');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.store_button{
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 20px auto;
  padding: 2px;
  width: 90%;
  background: linear-gradient(to bottom right, #6bb559, #6abeb9);
  border: 2px solid #224696;
  color: white;
  font-size: 22px;
  font-weight: bold;
  border-radius: 25px;
  transition: all 0.3s ease-in-out;
  @media screen and (max-width: $tabletWidth){
    font-size: 16px;
    padding: 3px;
  }
  .store_button_style{
    display: flex;
    align-items: center;
    justify-content: space-around;
    position: relative;
    padding: 5px;
    border: 2px solid #224696;
    border-radius: 25px;
    background: linear-gradient(to bottom, #fffefe, #6ab146 ,#91be4c);
    width: 100%;
    &.head{
      cursor: default;
    }
    .arrow {
      position: absolute;
      top:0;
      bottom:0;
      right: 10px;
      width: 45px;
      height: 45px;
      @media screen and (max-width: $tabletWidth){
        width: 35px;
        height: 35px;
      }
    }
  }
  &:hover {
    background-color: bisque;
  }
  .shipped-button{
    font-size: 14px;
    &.button{
      cursor: pointer;
      border-bottom: 1px solid #fff;
      &:hover{
        color: #dedede;
        border-bottom: 1px solid #dedede;
      }
    }
    @media screen and (max-width: $tabletWidth){
      font-size: 10px;
    }
  }
}
</style>
